import React, { useState } from "react";
import "./trivvyCommonComponents.css";
import { Modal, ModalBody, ModalHeader, Row, Col } from "reactstrap";
import { TRIVVY_LANGUAGES } from "../../pages/trivia/data";

export default function SupportedLanguagesText({
  showDataTrivvytext,
  invalidTranslationPlan,
  noTranslationLanguage,
}) {
  const [languagesModal, setLanguagesModal] = useState(false);

  return (
    <div className="mb-2">
      {languagesModal && (
        <Modal size="sm" isOpen={true}>
          <ModalHeader
            toggle={() => {
              setLanguagesModal(false);
            }}
            className={"trivia_modal_header_bg"}
          >
            Supported Languages
          </ModalHeader>
          <ModalBody>
            <Row>
              {TRIVVY_LANGUAGES.map((x) => (
                <Col md={3}>{x.label}</Col>
              ))}
            </Row>
          </ModalBody>
        </Modal>
      )}
      {showDataTrivvytext ? (
        <span className="language-support-text">
          Note: Trivvy will be created in the language of the content source.{" "}
          <span
            className="click-here-link-text"
            onClick={() => {
              setLanguagesModal(true);
            }}
          >
            Click here
          </span>{" "}
          to see other supported languages, if not in English.
         
        </span>
      ) : invalidTranslationPlan ? (
        <span className="">
          Sorry, this item doesnt appear to be in English. Either please upload
          it in English OR upgrade so that you may create trivvys in one of our{" "}
          <span
            className="click-here-link-text"
            onClick={() => {
              setLanguagesModal(true);
            }}
          >
            accepted language
          </span>{" "}
        </span>
      ) : noTranslationLanguage ? (
        <span className="">
          Sorry, this item doesnt appear to be in one of our{" "}
          <span
            className="click-here-link-text"
            onClick={() => {
              setLanguagesModal(true);
            }}
          >
            accepted languages
          </span>
          . Please upload this item in one of those languages. Thank you{" "}
        </span>
      ) : (
        <span className="language-support-text">
          Note: If document is not in English,{" "}
          <span
            className="click-here-link-text"
            onClick={() => {
              setLanguagesModal(true);
            }}
          >
            Click here
          </span>{" "}
          to see other supported languages.{" "}
        </span>
      )}
    </div>
  );
}
